import "./Gender.scss";
import {
  CONST_GENDER_FEMALE,
  CONST_GENDER_MALE,
  isValidGender,
} from "../../helpers";

import { useState, useEffect } from "react";
// import { VideoMobile } from "../VideoMobile";

export const Gender = ({ data, setData, nextStep }) => {
  const [errorGender, setErrorGender] = useState(null);

  const handleAddGender = (e) => {
    e.preventDefault();
    setErrorGender(null);
    if (!isValidGender) {
      setErrorGender("Please choose your gender");
    } else {
      setData({ ...data, gender: parseInt(e.target.value) });
      nextStep();
    }
  };

  useEffect(() => {
    setData({ ...data, gender: CONST_GENDER_MALE });
  }, []);

  return (
    <div className="global__wrapper">
      {/* <VideoMobile /> */}
      <div className="gender__text-block">
        <h1>Chat with me on Cupidlee!💕</h1>
        <p>Join the platform and chat with verified singles across the globe</p>
      </div>
      <form className="form__global">
        <h3 className="title__global">What is your gender?</h3>
        <div className="form__gender">
          <label className="container">
            <input
              className="gender"
              type="radio"
              name="gender"
              value={CONST_GENDER_MALE}
              onClick={(e) => handleAddGender(e)}
              defaultChecked={CONST_GENDER_MALE}
            />
            <div className="male">Male</div>
          </label>
          <label className="container">
            <input
              className="gender"
              type="radio"
              name="gender"
              value={CONST_GENDER_FEMALE}
              onClick={(e) => handleAddGender(e)}
            />
            <div className="female">Female</div>
          </label>
        </div>
        {errorGender && <p className="error-text">{errorGender}</p>}
      </form>
    </div>
  );
};
